module.exports = __webpack_public_path__ + "img/shouye-fuhua-png-02.534cf2c0.svg";